export type OpenSections = Record<string, boolean>;

type Section = { sectionTitle: string };

// Sections start expanded so the page reads the same as before collapsing was added,
// and so jumping to a section from the nav always lands on visible content
export function initialOpenSections(sections: Section[]): OpenSections {
  return sections.reduce((open: OpenSections, section) => {
    open[section.sectionTitle] = true;
    return open;
  }, {});
}

export function anyOpen(open: OpenSections): boolean {
  return Object.keys(open).some((sectionTitle) => open[sectionTitle]);
}

export function toggleSection(open: OpenSections, sectionTitle: string): OpenSections {
  return { ...open, [sectionTitle]: !open[sectionTitle] };
}

// Returns the same object when the section is already open, so React can skip the re-render
export function openSection(open: OpenSections, sectionTitle: string): OpenSections {
  if (open[sectionTitle]) return open;

  return { ...open, [sectionTitle]: true };
}

export function setAllSections(open: OpenSections, isOpen: boolean): OpenSections {
  return Object.keys(open).reduce((next: OpenSections, sectionTitle) => {
    next[sectionTitle] = isOpen;
    return next;
  }, {});
}
